const parser = (data) => {
  if (!Array.isArray(data)) {
    return data;
  }

  // example of a parser for combining data from multiple columns to present them in a single column
  // this one do nothing yet
  return data.map(row => row);
};

export default parser;
